import React from "react";
import { useSelector } from "react-redux";

import { Container, TextContainer, ImagesContainer, Title, SubTitle, ImageWoman, ImageNote } from "./styles";

//Assets
import happyWoman from "../../assets/img/happy-woman.svg";
import noteOrange from "../../assets/img/note-orange.svg";
import noteYellow from "../../assets/img/note-yellow.svg";

const DashboardHeader = () => {
    const login = useSelector((state: {login: any}) => state.login);

    const getBusinessName = () => {
        if(login.user.branchs !== null){
            if(login.user.branchs.businessDescription !== null){
                if(login.user.branchs.businessDescription.length > 20){
                    return `${login.user.branchs.businessDescription.slice(0, 19)}...`
                }
            } else {
                return `${login.user.branchs.businessName.slice(0, 25)}...`;    
            }
    
            return login.user.branchs.businessDescription;
        } else {
            return ""
        }
    }

    return(
        <Container>
            <TextContainer>
                <Title>{getBusinessName()}</Title>
                <SubTitle>Seja bem-vindo novamente. Estamos felizes em lhe ver 😁</SubTitle>
            </TextContainer>

            <ImagesContainer>
                <ImageNote src={noteOrange} style={{marginTop: 25, marginRight: 15}}/>
                <ImageWoman src={happyWoman} style={{marginTop: -8}}/>
                <ImageNote src={noteYellow} style={{marginTop: 12, marginLeft: 3}}/>
            </ImagesContainer>
        </Container>
    )
}

export default DashboardHeader;